import { useSignalRHub } from './useSignalRHub';
import { HubsNames } from '../stores/useSignalR';
import {
  SIGNALR_STREAM_ALARMS_ENDPOINT,
  SIGNALR_STREAM_DELIVERY_ENDPOINT,
  SIGNALR_STREAM_DELIVERY_SUMMARY,
  SIGNALR_STREAM_FILTER_OPTIONS,
  SIGNALR_STREAM_MPA_TRANSMISSION,
} from '../utils/urlUtils';
import { ProfileSignalRQueryOperation } from '../types/api/profile';

export const useSignalRHubsSetup = () => {
  useSignalRHub(
    HubsNames.bunkeringDashboard,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeProfileDataSimplified,
  );

  useSignalRHub(
    HubsNames.mfmComparsion,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeProfileDataSimplified,
  );

  useSignalRHub(
    HubsNames.aggregateDashboard,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeProfileSummary,
  );

  useSignalRHub(
    HubsNames.aggregateOverview,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeProfileSummary,
  );

  useSignalRHub(
    HubsNames.bunkeringOverview,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeProfileDataSimplified,
  );

  useSignalRHub(
    HubsNames.deliverySummary,
    SIGNALR_STREAM_DELIVERY_SUMMARY,
    ProfileSignalRQueryOperation.SubscribeDeliverySummaryData,
  );

  useSignalRHub(
    HubsNames.deliverySummaryRightDrawer,
    SIGNALR_STREAM_DELIVERY_SUMMARY,
    ProfileSignalRQueryOperation.SubscribeDeliverySummaryData,
  );

  useSignalRHub(
    HubsNames.bunkeringRawData,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeProfileData,
  );

  useSignalRHub(
    HubsNames.alarmsSummary,
    SIGNALR_STREAM_ALARMS_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeMfmAlertsData,
  );

  useSignalRHub(
    HubsNames.alarmsOverview,
    SIGNALR_STREAM_ALARMS_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeMfmAlertsData,
  );

  useSignalRHub(
    HubsNames.filterOptions,
    SIGNALR_STREAM_FILTER_OPTIONS,
    ProfileSignalRQueryOperation.GetFilterOptions,
  );

  useSignalRHub(
    HubsNames.activeSessionBunkeringDashboard,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeActiveSessionProfileDataSimplified,
  );

  useSignalRHub(
    HubsNames.mpaStatusLogs,
    SIGNALR_STREAM_MPA_TRANSMISSION,
    ProfileSignalRQueryOperation.SubscribeTransmissionDetails,
  );

  useSignalRHub(
    HubsNames.mpaStatusSubmit,
    SIGNALR_STREAM_MPA_TRANSMISSION,
    ProfileSignalRQueryOperation.SubmitSummary,
  );

  useSignalRHub(
    HubsNames.bunkeringStatusLogs,
    SIGNALR_STREAM_DELIVERY_ENDPOINT,
    ProfileSignalRQueryOperation.SubscribeMfmDeviceBunkeringStatus,
  );
};
